import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { theme } from "../../Assets/Theme/theme";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import { BASE_URL } from "../../Assets/Constants";
import TextInput from "../../Components/Common/TextInput";
import CustomButton from "../../Components/Common/CustomButton";
import logo from "../../Assets/Images/logo.png";
import login_bg from "../../Assets/Images/login-bg.png";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

function ForgotPwd() {
    const [inputValues, setInputValues] = useState({
        email: "",
        password: "",
    });
    const [errors, setErrors] = useState([])
    const [isHovered, setIsHovered] = useState(false);
    const [loading, setLoading] = useState(false)
    const navigate = useNavigate();

    const handleChange = (field, value) => {
        setInputValues((prevData) => ({ ...prevData, [field]: value }));
    };

    const handleSubmit = async () => {
        if (!inputValues.email) {
            setErrors([{ path: "email", msg: "Email is required" }]);
            return;
        }

        setLoading(true);
        try {
            const response = await axios.post(`${BASE_URL}/forgot/step1/password`, {
                email: inputValues.email,
            });

            if (response?.data?.status) {
                toast.success("Otp code has been sent to your email successfully", {
                    position: "top-right",
                    autoClose: 3000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                    style: { backgroundColor: 'orange', color: 'white' },
                });
                navigate("/otp", { state: {email: inputValues?.email} });
            } else {
                toast.error("Failed", {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "colored",
                });
            }
        } catch (error) {
            toast.error(
                error.response?.data?.message || "Unable to send OTP. Please try again."
            );
        } finally {
            setLoading(false);
        }
    };

    const getErrorMessage = (field) => {
        const fieldError = errors?.find((err) => err?.path === field);
        return fieldError?.msg || null;
    };

    const clearErrorMessage = (field) => {
        setErrors((prevErrors) => prevErrors.filter((err) => err?.path !== field));
    };

    useEffect(() => {
        const handleKeyPress = (event) => {
            if (event.key === "Enter") {
                handleSubmit()
            }
        };

        window.addEventListener("keypress", handleKeyPress);

        return () => {
            window.removeEventListener("keypress", handleKeyPress);
        };
    }, [inputValues]);

    return (
        <Box display={"flex"} overflow={"hidden"}>
            <IconButton
                onClick={() => navigate(-1)}
                sx={{
                    position: "absolute",
                    top: 16,
                    left: 16,
                    color: theme.colors.primary,
                }}
            >
                <ArrowBackIcon sx={{ fontSize: 36 }} />
            </IconButton>

            {/* Left Section */}
            <Box
                width={"62%"}
                display={"flex"}
                flexDirection={"column"}
                alignContent={"center"}
                justifyContent={"center"}
                sx={{
                    "@media (max-width:900px)": {
                        width: "100%",
                    },
                }}
            >
                <Box marginBottom={5} textAlign={"center"}>
                    <img src={logo} width={80} height={74} />
                </Box>
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    textAlign="center"
                    color={theme.colors.text}
                    sx={{
                        width: "100%",
                        padding: "0 20px",
                    }}
                >
                    <Typography variant="h5" fontWeight={600}>
                        Forgot Password?
                    </Typography>

                    <Typography
                        variant="body2"
                        color="#6c757d"
                        marginBottom={1}
                        marginTop={1}
                        sx={{ fontFamily: "Nunito, sans-serif", maxWidth: "50%", alignSelf: 'center' }}
                    >
                        Enter your email address, and we'll send you an OTP verification code to reset your password
                    </Typography>
                </Box>
                <Box
                    width={"60%"}
                    margin={"0 auto"}
                    sx={{
                        "@media (max-width:400px)": {
                            width: "80%",
                        },
                    }}
                >
                    <Box>
                        <TextInput
                            label={"Email"}
                            placeholder={"Enter Your Email..."}
                            type={"email"}
                            name={"email"}
                            onChange={(e) => {
                                handleChange("email", e.target.value)
                                clearErrorMessage("email");
                            }}
                        />
                        {getErrorMessage("email") && (
                            <Box color="red" mb={2}>
                                {getErrorMessage("email")}
                            </Box>
                        )}
                        <CustomButton onClick={handleSubmit}>
                            {loading ? <CircularProgress size={30} sx={{ color: "white" }} /> : 'Send'}
                        </CustomButton>
                    </Box>
                </Box>
            </Box>

            {/* Right Section */}
            <Box
                width="35%"
                display="flex"
                justifyContent="center"
                alignItems="center"
                sx={{
                    "@media (max-width: 900px)": {
                        display: "none",
                    },
                    "@media (min-width: 900px) and (max-width: 1200px)": {
                        height: "20vh",
                    },
                    "@media (min-width: 900px)": {
                        height: "90vh",
                    },
                }}
            >
                <img
                    src={login_bg}
                    alt="Login Background"
                    style={{ width: "100%", height: "100%" }}
                />
            </Box>
        </Box>
    );
}

export default ForgotPwd;
